import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface VolunteerOpportunityCardProps {
  title: string;
  location: string;
  timeCommitment: string;
  skills: string[];
  description: string;
  image: string;
  alt: string;
  onApply: () => void;
}

const VolunteerOpportunityCard: React.FC<VolunteerOpportunityCardProps> = ({
  title,
  location,
  timeCommitment,
  skills,
  description,
  image,
  alt,
  onApply,
}) => {
  return (
    <div className="bg-card rounded-lg overflow-hidden border border-border hover:shadow-lg transition-all duration-300">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
      </div>

      <div className="p-6">
        <h3 className="text-xl font-headline font-bold text-foreground mb-3">{title}</h3>

        <div className="space-y-2 mb-4">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="MapPinIcon" size={16} className="text-primary" />
            <span>{location}</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="ClockIcon" size={16} className="text-primary" />
            <span>{timeCommitment}</span>
          </div>
        </div>

        <p className="text-sm text-foreground mb-4 line-clamp-3">{description}</p>

        <div className="mb-4">
          <h4 className="text-xs font-semibold text-muted-foreground mb-2">Required Skills:</h4>
          <div className="flex flex-wrap gap-2">
            {skills.map((skill, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-primary/10 text-primary text-xs rounded-full"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        <button
          onClick={onApply}
          className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-md font-medium text-sm transition-all duration-300 hover:bg-primary/90 hover:shadow-md"
        >
          Apply Now
        </button>
      </div>
    </div>
  );
};

export default VolunteerOpportunityCard;